// Lib
import { flatMap, flow, compact } from 'lodash/fp';

export default (fn) => flow(flatMap(fn), compact);
